import React from 'react';
import { StyleSheet } from 'react-native';
import { MB_SVG_X } from '@mightybyte/rnw.components.svg-components';
import { MB_Button, MB_ButtonProps } from '@mightybyte/rnw.components.button';
import { COLORS } from './constants';
import { isMobile } from '@mightybyte/rnw.utils.device-info';
import { mbApplyTransparency } from '@mightybyte/rnw.utils.style-utils';

const MB_ModalUtilCloseButton = ({ onPressed, closeButtonProps, hideCloseButton, xSize = 20, xColor = 'white' }: {
    /**
     * Callback called when the close button is pressed.
     */
    onPressed?: () => void,

    /**
     * Props to pass to the close button.
     */
    closeButtonProps?: MB_ButtonProps,

    /**
     * If true, the close button will be hidden.
     */
    hideCloseButton?: boolean,

    /**
     * The size of the close button.
     * 
     * @default 20
     */
    xSize?: number,

    /**
     * The color of the close button.
     * 
     * @default 'white'
     */
    xColor?: string
}) => {

    if (hideCloseButton) {
        return null;
    }

    const style = closeButtonProps?.style;

    return (
        <MB_Button
            title=""
            leftElement={<MB_SVG_X size={xSize} color={xColor} />}
            onPress={onPressed}
            {...closeButtonProps}
            style={[styles.closeButton, style]}
        />
    );
};

export { MB_ModalUtilCloseButton };

const styles = StyleSheet.create({
    closeButton: {
        borderRadius: 6,
        width: 32,
        height: 32,
        position: 'absolute',
        right: isMobile ? 8 : 10,
        top: isMobile ? 8 : 10,
        paddingHorizontal: 0,
        backgroundColor: mbApplyTransparency(COLORS.white, 0.05),
        zIndex: 1,
    },
});
